import * as helpers from './helpers';
import mobileMenu from './mobileMenu';
import { Modal } from './lib/modal.ts';

const DOM = {};
const menuQuery = window.matchMedia('(max-width:1200px)');
let isOpen = false;

/* Getting All the elements for Desktop and Mobile Menu */
const cacheDOM = () => {
    DOM.sidebarMenu = document.querySelector('.sidebar-menu');
    DOM.nav = document.querySelector('.nav');
    DOM.navLinks = document.querySelectorAll('.nav__listItem');
    DOM.openMenuElement = document.querySelector('.nav__link--open-menu');
    DOM.menuLevels = document.querySelectorAll('.sidebar-menu__level');
    DOM.listItemsSM = document.querySelectorAll('.sidebar-menu__list > li');
    DOM.backgrounds = document.querySelectorAll(
        '.sidebar-menu__background-item'
    );
    DOM.firstLevel = document.querySelector('.sidebar-menu__level-first');
    DOM.allMenuLinks = document.querySelectorAll('sidebar-menu__link');
    DOM.courseTitle = document.querySelector('.nav__course-title');

    if (DOM.menuLevels.length >= 1) {
        DOM.arrayLevels = [...DOM.menuLevels];
    }
};

/* Function to change Backgrounds in Desktop */
const changeBackground = (level) => {
    const levelIndex = DOM.arrayLevels.indexOf(level);
    const className = 'sidebar-menu__background-item--active';

    if (DOM.backgrounds.length > 0) {
        DOM.backgrounds.forEach((bg) => {
            bg.classList.remove(className);

            if (bg.dataset.menuBg == levelIndex) {
                bg.classList.add(className);
            }
        });
    }
};

/* Removing Hovers in Desktop Links */
const removeHovers = (links) => {
    links.forEach((link) => {
        link.classList.remove('sidebar-menu__link--active');
    });
};

/* Function to Open Desktop Level */
const openLevel = (list) => {
    const level = list.parentElement;
    const nextLevel = level.nextElementSibling;

    changeBackground(level);
    level.classList.remove('sidebar-menu__level--closed');

    if (nextLevel && nextLevel.classList.contains('sidebar-menu__level')) {
        nextLevel.classList.add('sidebar-menu__level--closed');
        nextLevel.classList.remove('sidebar-menu__level--hide');
    }
};

/* Function to CLose Desktop Level */
const closeLevel = (levelToClose) => {
    if (levelToClose) {
        const prevLevel = levelToClose.previousElementSibling;
        const levelLinks = levelToClose.querySelectorAll(
            '.sidebar-menu__list--show>li>a'
        );
        const prevLevelLinks = prevLevel.querySelectorAll(
            '.sidebar-menu__list--show>li>a'
        );
        const nextLevelIndex = DOM.arrayLevels.indexOf(levelToClose) + 1;

        DOM.arrayLevels.slice(nextLevelIndex).forEach((lvl) => {
            lvl.classList.remove('sidebar-menu__level--closed');
            lvl.classList.add('sidebar-menu__level--hide');
        });

        changeBackground(levelToClose.previousElementSibling);
        levelToClose.classList.add('sidebar-menu__level--closed');
        removeHovers(levelLinks);
        removeHovers(prevLevelLinks);
    }
};

/* Function to string the string to search the list to open in future Functions */
const getList = (listItem) => {
    const list = listItem.parentElement;
    const listItemOption = listItem.dataset.option;
    const listIndex = list.dataset.index ? `${list.dataset.index}-` : '';
    return document.querySelector(
        `[data-index="${listIndex + listItemOption}"]`
    );
};

/* Function that Show's a List or Open the level if it's not opened or close it if it's opened but there is no list */
const showList = (listItem) => {
    const list = listItem.parentElement;
    const listToShow = getList(listItem);
    const listLinks = list.querySelectorAll('li>a');

    removeHovers(listLinks);
    listItem.firstElementChild.classList.add('sidebar-menu__link--active');

    if (listToShow) {
        const levelToOpen = listToShow.parentElement;
        const levelToOpenLists = levelToOpen.querySelectorAll('ul');

        if (levelToOpen.classList.contains('sidebar-menu__level--closed')) {
            openLevel(listToShow);
        } else {
            closeLevel(levelToOpen.nextElementSibling);
        }

        levelToOpenLists.forEach((listElement) => {
            listElement.classList.remove('sidebar-menu__list--show');
            if (listElement === listToShow) {
                listToShow.classList.add('sidebar-menu__list--show');
            }
        });
    }
};

/* Function that toggles the desktop Menu */
const toggleMenu = () => {
    const firstList = DOM.firstLevel.firstElementChild;

    DOM.nav.classList.toggle('nav--overlayed');

    if (DOM.courseTitle) {
        DOM.courseTitle.classList.toggle('nav__course-title--hide');
    }

    DOM.navLinks.forEach((link) => {
        if (link.firstElementChild !== DOM.openMenuElement) {
            link.classList.toggle('nav__listItem--hide');
        } else if (link.firstElementChild.firstElementChild.classList != null) {
            link.firstElementChild.firstElementChild.classList.toggle(
                'svg-close'
            );
        }
    });

    if (!isOpen) {
        DOM.sidebarMenu.classList.add('sidebar-menu--opened');
        openLevel(firstList);
        firstList.classList.add('sidebar-menu__list--show');
    } else {
        DOM.menuLevels.forEach((level) => {
            if (level === DOM.firstLevel) {
                level.classList.add('sidebar-menu__level--closed');
            } else {
                level.classList.remove('sidebar-menu__level--closed');
                level.classList.add('sidebar-menu__level--hide');
            }
        });

        DOM.sidebarMenu.classList.remove('sidebar-menu--opened');
        removeHovers(DOM.allMenuLinks);
    }
};

/* Function that print the Dropdown icon in the list Items */
const dropdownElements = () => {
    DOM.listItemsSM.forEach((listItem) => {
        const list = listItem.parentElement;
        const itemLink = listItem.firstElementChild;
        const level = list.parentElement;
        const childList = getList(listItem);

        if (childList) {
            itemLink.classList.add('sidebar-menu__link--dropdown');
        }

        listItem.firstElementChild.addEventListener('mouseover', (e) => {
            showList(e.target.parentElement);
            if (!childList && level.nextElementSibling) {
                closeLevel(level.nextElementSibling);
                e.target.classList.add('sidebar-menu__link--active');
            }
        });
        listItem.firstElementChild.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown') {
                showList(e.target.parentElement);
                if (!childList && level.nextElementSibling) {
                    closeLevel(level.nextElementSibling);
                    e.target.classList.add('sidebar-menu__link--active');
                }
            }
        });
        listItem.firstElementChild.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                const openMenuLink = document.querySelector(
                    'a.nav__link--open-menu'
                );
                if (openMenuLink) {
                    const status = openMenuLink.getAttribute('data-status');
                    console.log(status);
                    if (status !== 'closed') {
                        openMenuLink.click();
                    }
                }
            }
        });
    });
};

const toggleMobileModal = () => {
    const mobileModal = mobileMenu.getInstance();

    isOpen = Modal.isOpen(mobileModal);

    if (isOpen) mobileModal.hide();
    else mobileModal.show();
};

/* Function that handles if It's the desktop or Mobile menu who should open */
const handleToggleMenu = (e) => {
    e.preventDefault();

    const screenWidth = helpers.getWidth();

    /* Desktop */
    if (screenWidth >= 1200) {
        if (!isOpen && DOM.openMenuElement.dataset.status === 'closed') {
            DOM.openMenuElement.dataset.status = 'menu';
            document.body.style.overflow = 'hidden';
            toggleMenu();
            isOpen = true;
        } else if (isOpen) {
            DOM.openMenuElement.dataset.status = 'closed';
            document.body.style.overflow = '';
            toggleMenu();
            isOpen = false;
        }
        /* Mobile */
    } else if (screenWidth < 1200) {
        toggleMobileModal();
    }
};

/* Handles which desktop level should close */
const handleCloseLevel = (level) => (e) => {
    const elementMouseIsOver = helpers.getElementOver(e);
    if (
        elementMouseIsOver &&
        elementMouseIsOver.parentElement === level.previousElementSibling &&
        elementMouseIsOver !== DOM.openMenuElement &&
        !elementMouseIsOver.classList.contains('sidebar-menu__background-item')
    ) {
        closeLevel(level);
    }
};

/* Function to control the change between desktop and mobile with the menu opened */
const hideMenuQuery = (query) => {
    if (isOpen && query.matches) toggleMenu();
    else mobileMenu.getInstance().hide();

    DOM.openMenuElement.dataset.status = 'closed';
    isOpen = false;
};

const bindEvents = () => {
    DOM.openMenuElement.addEventListener('click', handleToggleMenu);
    DOM.menuLevels.forEach((level) => {
        level.addEventListener('mouseleave', handleCloseLevel(level));
    });
    menuQuery.addListener(hideMenuQuery);
};

const init = () => {
    cacheDOM();
    if (DOM.nav && DOM.sidebarMenu && DOM.openMenuElement) {
        bindEvents();
        dropdownElements();
    }

    mobileMenu.init();
};

const menu = { init };
export default menu;
